import { render, staticRenderFns } from "./DmsUserProfileComponent.vue?vue&type=template&id=bab81674"
import script from "./DmsUserProfileComponent.vue?vue&type=script&lang=js"
export * from "./DmsUserProfileComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports